import React from 'react';

import cx from 'classnames';

import { CartItemType } from '@zola-helpers/client/dist/es/@types/cart';

import { compactCurrencyFilter, hasDiscountedPrice } from '../utils/PricingUtils';

import styles from './cartItemPrice.module.less';

export const CartItemPrice = ({
  item,
  className,
  smallerFont = false,
}: {
  item: CartItemType;
  className?: string;
  smallerFont?: boolean;
}) => {
  const showOriginalPrice = hasDiscountedPrice(item);

  return (
    <div className={cx(styles.cartItemUnitPrice, className, { [styles.smaller]: smallerFont })}>
      {compactCurrencyFilter(item.contribution?.adjustedPrice)}
      {showOriginalPrice && (
        <div className={styles.cartItemOriginalPrice}>
          {compactCurrencyFilter(item.contribution?.price)}
        </div>
      )}
    </div>
  );
};
